import React from "react";
const WaveForm = ({ id = "waveform", children }) => {
    return React.createElement("div", { id: id }, children);
};
export default WaveForm;
